/**
 * Returns true if the cart contains at least one subscription.
 */
export const doesCartContainSubscription = (cart: Cart): boolean => {
  return Array.isArray(cart.kits) && cart.kits.some((kit) => kit.isPrepaidSubscription);
};

/**
 * Extracts coupon code from a kit with fallback logic:
 * 1. discountProgram (program_code)
 * 2. discountLabel (label)
 * 3. discountDescription (discount_description)
 */
export const getCouponFromKit = (kit: Kit): string => {
  if (!kit.discounted) return '';
  return kit.discountProgram || kit.discountLabel || kit.discountDescription || '';
};

/**
 * Extracts all unique coupon codes from a cart.
 * Uses fallback logic: discountProgram -> discountLabel -> discountDescription
 */
export const getUniqueCouponsFromCart = (cart: Cart): string[] => {
  return Array.from(
    new Set(cart.kits.map((kit) => getCouponFromKit(kit)).filter((coupon) => coupon !== '')),
  );
};

/**
 * Normalizes email by:
 * - Lowercasing
 * - Removing "+tag"
 */
export const normalizeEmail = (email: string): string => {
  const [localPart, domain] = email.toLowerCase().split('@');
  const name = localPart.split('+')[0];
  return `${name}@${domain}`;
};
